import { zod } from "@/BaseComponent";

const regexForPassword = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_\+\-=\[\]{}|;:'",.<>?/])[A-Za-z\d!@#$%^&*()_\+\-=\[\]{}|;:'",.<>?/]{8,}$/;

export default {
    login: zod.object({
        username: zod.string().min(3, "아이디를 3글자 이상 입력해주세요."),
        password: zod.string().min(1, "비밀번호를 입력해주세요"),
    }),
    changePw: zod
        .object({
            pw: zod.string().regex(regexForPassword, "비밀번호는 소문자, 숫자, 특수문자를 포함한 8자 이상이어야 합니다."),
            pw_re: zod.string().regex(regexForPassword, "비밀번호를 확인해주세요"),
        })
        .refine((data) => data.pw && data.pw_re && data.pw === data.pw_re, {
            message: "비밀번호가 다릅니다.",
            path: ["pw_re"],
        }),
};
